var _path, _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSettings = function SvgSettings(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#556575",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M8.532 1.998c.281 0 .533.177.628.442l.338.943a.671.671 0 0 0 .295.352l1.005.58a.667.667 0 0 0 .452.08l.987-.179a.667.667 0 0 1 .697.323l.533.92a.667.667 0 0 1-.066.765l-.648.765a.666.666 0 0 0-.158.431v1.16c0 .159.056.311.158.432l.648.765a.667.667 0 0 1 .066.765l-.533.92a.667.667 0 0 1-.696.323l-.987-.178a.667.667 0 0 0-.452.078l-1.005.58a.67.67 0 0 0-.295.353l-.339.944a.667.667 0 0 1-.628.441H7.465a.667.667 0 0 1-.628-.441l-.338-.944a.673.673 0 0 0-.295-.352l-1.005-.58a.667.667 0 0 0-.452-.08l-.987.179a.667.667 0 0 1-.697-.323l-.533-.92a.667.667 0 0 1 .066-.765l.648-.765a.667.667 0 0 0 .158-.431V7.42a.667.667 0 0 0-.158-.432l-.641-.765a.667.667 0 0 1-.067-.765l.534-.92a.667.667 0 0 1 .696-.323l.987.178c.155.028.315 0 .452-.078l1.005-.58a.673.673 0 0 0 .295-.353l.338-.943a.667.667 0 0 1 .622-.442z",
    clipRule: "evenodd"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 8,
    r: 1.834,
    stroke: "#556575",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
export { SvgSettings as ReactComponent };
export default "data:image/svg+xml;base64,ZXhwb3J0IGRlZmF1bHQgX193ZWJwYWNrX3B1YmxpY19wYXRoX18gKyAiNTBjODNkOTBkYTkzNjA2MWU0ZTQ3YWQ4NDE4M2FiZGIuc3ZnIjs=";